'use client';
import { useIsomorphicLayoutEffect } from 'framer-motion';
import { useState } from 'react';

const useComponentBoundingBox = () => {
    const [ref, setRef] = useState(null);
    const [boundingBox, setBoundingBox] = useState();
    useIsomorphicLayoutEffect(() => {
        if (!ref)
            return;
        const handleResize = () => {
            setBoundingBox(ref.getBoundingClientRect());
        };
        handleResize();
        if (typeof ResizeObserver === 'function') {
            const resizeObserver = new ResizeObserver(() => handleResize());
            resizeObserver.observe(ref);
            return () => {
                resizeObserver.disconnect();
            };
        }
        else {
            window.addEventListener('resize', handleResize);
            return function () {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, [ref]);
    return [setRef, boundingBox];
};

export { useComponentBoundingBox };
//# sourceMappingURL=use-component-bounding-box.js.map
